module.exports = __webpack_public_path__ + "static/media/site-lock-br.1f203b49.png";